// Mercapoli - Términos y Condiciones
import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText, Users, ShoppingBag, Truck, CreditCard, AlertTriangle, Scale } from 'lucide-react';

const TermsConditions = () => {
  const LOGO_URL = "https://customer-assets.emergentagent.com/job_mercadelivery-1/artifacts/5y038jeg_icono_mercapoli.png";
  const lastUpdated = "31 de Diciembre, 2024";

  const sections = [
    {
      icon: Users,
      title: "1. Aceptación de Términos",
      content: `Al registrarte y usar Mercapoli, aceptas estos términos y condiciones. Si no estás de acuerdo, 
      no utilices nuestros servicios. Nos reservamos el derecho de modificar estos términos en cualquier momento, 
      notificándote a través de la app o por correo electrónico.`
    },
    {
      icon: ShoppingBag,
      title: "2. Descripción del Servicio",
      content: `Mercapoli es una plataforma que conecta usuarios con comercios locales (restaurantes, farmacias, 
      tiendas, floristerías, etc.) para la compra y entrega de bienes físicos. NO somos responsables de la calidad 
      de los productos, que es responsabilidad exclusiva de cada comercio asociado.`
    },
    {
      icon: Truck,
      title: "3. Entregas y Repartidores",
      content: `Los repartidores son colaboradores independientes que utilizan nuestra plataforma. El tiempo de 
      entrega estimado es aproximado y puede variar según condiciones de tráfico, clima o disponibilidad. 
      Haremos nuestro mejor esfuerzo para que tu pedido llegue en el tiempo indicado.`
    },
    {
      icon: CreditCard,
      title: "4. Pagos y Precios",
      content: `Los precios mostrados incluyen impuestos aplicables. Los pagos se procesan a través de proveedores 
      externos seguros (Stripe, MercadoPago). NO almacenamos datos de tarjetas de crédito. Los puntos DIGGII son 
      un programa de lealtad que puede ser modificado o descontinuado sin previo aviso.`
    },
    {
      icon: AlertTriangle,
      title: "5. Cancelaciones y Reembolsos",
      content: `Puedes cancelar un pedido antes de que el comercio comience a prepararlo. Una vez en preparación, 
      no se garantiza reembolso completo. Para solicitar reembolsos por productos defectuosos o pedidos incorrectos, 
      contacta a soporte dentro de las 24 horas siguientes a la entrega.`
    },
    {
      icon: Scale,
      title: "6. Responsabilidades del Usuario",
      content: `Te comprometes a: proporcionar información veraz, mantener la confidencialidad de tu cuenta, 
      no usar la plataforma para fines ilegales, y tratar con respeto a comercios y repartidores. Nos reservamos 
      el derecho de suspender cuentas que violen estos términos.`
    }
  ];

  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-background/95 backdrop-blur border-b border-border">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center gap-4">
              <Link to="/" className="p-2 -ml-2 rounded-lg hover:bg-muted">
                <ArrowLeft className="h-5 w-5" />
              </Link>
              <div className="flex items-center gap-2">
                <img src={LOGO_URL} alt="Mercapoli" className="h-8 w-8" />
                <span className="font-bold text-lg">Mercapoli</span>
              </div>
            </div>
          </div>
        </div>
      </header>

      <main className="container mx-auto px-4 py-8 max-w-3xl">
        {/* Title */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary/10 mb-4">
            <FileText className="h-8 w-8 text-primary" />
          </div>
          <h1 className="text-3xl font-bold mb-2">Términos y Condiciones</h1>
          <p className="text-muted-foreground">Última actualización: {lastUpdated}</p>
        </div>

        {/* Sections */}
        <div className="space-y-6">
          {sections.map((section, index) => (
            <div key={index} className="bg-card rounded-xl border border-border p-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
                  <section.icon className="h-5 w-5 text-primary" />
                </div>
                <h2 className="text-lg font-bold">{section.title}</h2>
              </div>
              <p className="text-muted-foreground leading-relaxed">{section.content}</p>
            </div>
          ))}
        </div>

        {/* Additional Terms */}
        <div className="mt-8 bg-amber-50 dark:bg-amber-950/30 rounded-xl p-6 border border-amber-200 dark:border-amber-800">
          <h3 className="font-bold text-amber-800 dark:text-amber-200 mb-3">Importante</h3>
          <ul className="space-y-2 text-amber-700 dark:text-amber-300 text-sm">
            <li>• Esta plataforma es para la venta de bienes físicos (comida, productos, etc.).</li>
            <li>• Los pagos NO son compras in-app, son transacciones por bienes y servicios reales.</li>
            <li>• Cualquier disputa se resolverá bajo las leyes del país donde operes.</li>
          </ul>
        </div>

        {/* Footer links */}
        <div className="mt-8 flex flex-wrap justify-center gap-4 text-sm">
          <Link to="/privacidad" className="text-primary hover:underline">Política de Privacidad</Link>
          <span className="text-muted-foreground">|</span>
          <Link to="/" className="text-primary hover:underline">Volver al inicio</Link>
        </div>
      </main>
    </div>
  );
};

export default TermsConditions;
